import brandTheme from '../../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const chartOptions = {
  chart: {
    type: 'column',
  },
  title: {
    text: '',
  },
  colors: [colors.primary],
  credits: false,
  legend: {
    enabled: false,
  },
  allowDecimals: false,
  rangeSelector: {
    selected: 1,
  },
  navigator: {
    enabled: false,
  },
  yAxis: {
    title: {
      text: '',
    },
  },
}
